





























import { Component, Vue } from 'vue-property-decorator'
import WidgetTitle from '@/components/common/WidgetTitle.vue'
import BezeButton from '@/components/common/BezeButton.vue'
import API from '@/api/auth'
import Loader from '@/components/common/Loader.vue'
import LoadStatusMessage from '@/components/common/LoadStatusMessage.vue'
import UserOrderList from '@/components/account/UserOrderList.vue'
import UserInfo from '@/components/account/UserInfo.vue'

@Component({
  components: {
    WidgetTitle,
    BezeButton,
    Loader,
    LoadStatusMessage,
    UserOrderList,
    UserInfo
  }
})
export default class Account extends Vue {
  isLoading = true
  hasLoadError = false

  created(): void {
    API.checkUser().catch(() => {
      this.hasLoadError = true
    }).finally(() => {
      this.isLoading = false
    })
  }

  logout(): void {
    this.$store.dispatch('logout').then(() => {
      this.$router.push('/')
    })
  }
}
